import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function Nopage() {
  const isLoginAuth = useSelector(
    (state) => state.persistedReducer.auth.authenticated
  );
  const currentUser = useSelector((state) => state.persistedReducer.auth.user);

  const { country, role } = currentUser ?? {};
  return (
    <>
      <section className="no-page-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="no-page">
                <div className="No-page-dv">
                  <h1>Sorry ! No Page Found</h1>
                  {isLoginAuth && role === "seller" ? (
                    <Link to="/seller-dashboard">Back To Seller Dashboard</Link>
                  ) : (
                    <Link to="/">Back To Home Page</Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Nopage;
